import { ConfigProvider as ConfigProvider$1 } from 'antd';
export { Avatar, Button, Carousel, Checkbox, Col, Collapse, Divider, Dropdown, Form, Input, Modal, Progress, Radio, Row, Select, Slider } from 'antd';
export { StyleProvider, createCache, extractStyle } from '@ant-design/cssinjs';
import React from 'react';
import { raFontBase, raColorPrimary, raColorSecondary } from '@riseart/antd-provider/dist/website/variables.less';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

var _excluded = ["children"];

/**
 * ConfigProvider
 *
 * @param {Object} props
 * @returns {Node}
 */
function ConfigProvider(_ref) {
  var children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ConfigProvider$1, _extends({
    wave: {
      disabled: true
    },
    theme: {
      hashed: false,
      token: {
        fontFamily: raFontBase,
        colorPrimary: raColorPrimary,
        colorSecondary: raColorSecondary,
        borderRadius: 0
      }
    }
  }, restProps || {}), children);
}

export { ConfigProvider };
